import {
   VideoConsultationReminderNotificationConfiguration,
   VideoConsultationReminderNotificationConfigurationQuery,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationVideoConsultationReminderToggleLoaderRenderProps = {
   notificationEnabled: boolean;
   messages: string[];
};

type PatientPhoneNotificationVideoConsultationReminderToggleLoaderProps = {
   children: (renderProps: PatientPhoneNotificationVideoConsultationReminderToggleLoaderRenderProps) => JSX.Element;
};

export const PatientPhoneNotificationVideoConsultationReminderToggleLoader = (
   props: PatientPhoneNotificationVideoConsultationReminderToggleLoaderProps
): JSX.Element | null => {
   const {
      data: videoConsultationReminderNotificationConfiguration,
      loading: videoConsultationReminderNotificationConfigurationLoading,
      error: videoConsultationReminderNotificationConfigurationError,
   } = useCqrsGet<VideoConsultationReminderNotificationConfiguration>(
      () => new VideoConsultationReminderNotificationConfigurationQuery()
   );

   if (
      videoConsultationReminderNotificationConfigurationLoading ||
      videoConsultationReminderNotificationConfigurationError
   ) {
      return null;
   }

   return props.children({
      notificationEnabled: videoConsultationReminderNotificationConfiguration.enabled,
      messages: videoConsultationReminderNotificationConfiguration.messages,
   });
};
